export default {
    created: "Mesajul WhatsApp a fost creat cu succes.",
    updated: "Mesajul WhatsApp a fost actualizat cu succes.",
    deleted: "Mesajul WhatsApp a fost sters cu succes.",
    restored: "Mesajul WhatsApp a fost restaurat cu succes.",
}
